import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoSummaryAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import { PaymentCardReaderDataService } from './paymentCardReader.dataservice';
import { PaymentCardReaderSummaryModel } from '../../../api/entity/paymentCardReaderSummary.model';
import { PaymentCardReaderSummaryConverter } from '../../../api/entity/converter/paymentCardReaderSummary.converter';
import { PaymentCardReaderModel } from '../../../api/entity/paymentCardReader.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentCardReaderSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    PaymentCardReaderSummaryModel,
    PaymentCardReaderSummaryConverter,
    PaymentCardReaderModel> {
    constructor(dataService: PaymentCardReaderDataService, converter: PaymentCardReaderSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentCardReaderModel {
        return new PaymentCardReaderModel();
    }
}
